import { cn } from "@gigpro/ui/tailwind/cn";
import { HireNotReadyDialog } from "domains/hire/containers/HireNotReadyDialog";
import { BaseLayout, type BaseLayoutSlots } from "layouts/BaseLayout";
import { useMarketplaceOverhaul } from "providers/LaunchDarkly";
import React from "react";
import { ShiftsBottomNavigation } from "./ShiftsBottomNavigation";
import { ShiftsMainNavContainer } from "./ShiftsMainNavContainer";
import { ShiftsSidebarNavContainer } from "./ShiftsSidebarNavContainer";

type ShiftsLayoutProps = React.PropsWithChildren<{
  slots?: BaseLayoutSlots;
  title: string;
  subtitle?: string;
  hideDefaultHeader?: boolean;
  className?: string;
  containerClassName?: string;
  contentClassName?: string;
  headerClassName?: string;
}>;

export const ShiftsLayout: React.FC<ShiftsLayoutProps> = ({
  children,
  slots,
  hideDefaultHeader,
  title,
  className,
  ...rest
}) => {
  const sidebar = useMarketplaceOverhaul("navigation");
  const NavContainer = sidebar ? ShiftsSidebarNavContainer : ShiftsMainNavContainer;
  return (
    <BaseLayout
      title={title}
      slots={slots}
      mainNav={<NavContainer title={title} hideDefaultHeader={hideDefaultHeader} slots={slots} />}
      bottomNav={<ShiftsBottomNavigation />}
      className={cn(sidebar && "md:flex-row", className)}
      {...rest}
    >
      {children}
      <HireNotReadyDialog />
    </BaseLayout>
  );
};
